/**
 * Synthetic localhost Dev Sign In accounts (`@dev.local`). Creation UI and
 * password are gated by {@link isDevAuthEnvironment} — never available on
 * production builds or deployed hosts.
 */

/**
 * @param {unknown} email
 * @returns {boolean}
 */
export function isDevLocalEmail(email) {
  return (
    typeof email === "string" && email.toLowerCase().endsWith("@dev.local")
  );
}

/**
 * Firestore user row from phone/code Dev Sign In. Treat as a dev account for
 * client tier bypass even if `isDevAccount` is missing (legacy docs) or
 * non-boolean.
 *
 * @param {Record<string, unknown> | null | undefined} userData
 * @returns {boolean}
 */
export function isDevAuthFirestoreUser(userData) {
  if (!userData || typeof userData !== "object") return false;
  if (userData.isDevAccount === true) return true;
  if (userData.isDevAccount === "true") return true;
  const devAuthCode = userData.devAuthCode;
  if (devAuthCode != null && String(devAuthCode).trim() !== "") return true;
  return isDevLocalEmail(userData.email);
}

/**
 * Whether app email-verification gates should treat this session as verified.
 * Client SDK cannot set `emailVerified` on `@dev.local` accounts; workforce
 * stamp sets it server-side when available, but patients often never stamp.
 * Treat those synthetic accounts as verified so role chrome (AppSwitcher,
 * drawers) matches the stamped role.
 *
 * @param {{ email?: string | null, emailVerified?: boolean } | null | undefined} user
 * @param {Record<string, unknown> | null | undefined} [userData]
 * @returns {boolean}
 */
export function isEmailVerifiedForApp(user, userData) {
  if (user?.emailVerified) return true;
  if (userData?.phoneVerified === true) return true;
  if (isDevLocalEmail(user?.email)) return true;
  return isDevAuthFirestoreUser(userData);
}

export default isDevAuthFirestoreUser;
